<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5 ml-4">
        <li>
          <router-link to="/inventory/item-model" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateItemModel") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card title no-shadow card-border>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.Make')"
            >
              <vs-input
                :label="$t('setup.label.Make')"
                class="min-w-200 w-full mb-2 starlabel"
                v-model="itemModel.make"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.Model')"
            >
              <vs-input
                :label="$t('setup.label.Model')"
                class="min-w-200 w-full mb-2 starlabel"
                v-model="itemModel.model"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold"
                >{{ $t("setup.label.ItemType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ItemType')"
              >
                <v-select
                  label="item"
                  :options="itemTypes"
                  v-model="itemModel.itemType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.item }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label font-semibold"
                >{{ $t("setup.label.NetworkElement")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.NetworkElement')"
              >
                <v-select
                  label="item"
                  v-model="provisioning"
                  :options="provsCodes"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2 font-semibold"
                >
                  <template v-slot:option="option">{{ option.item }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="handleCreateModel"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
const itemModelEmptyObj = {
  itemType: "",
  locale: "en",
  make: "",
  model: "",
  provisioningId: 0,
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      itemModel: itemModelEmptyObj,
      itemTypes: ["SD", "HD", "PVR"],
      // provisionDatas: [],
      data: {},
      provsCodes: [],
      provsIds: [],
      provisioning: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      provisionDatas: (state) => state.itemModel.provisionDatas,
    }),
  },
  methods: {
    async handleCreateModel() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        let payload = {
          make: this.itemModel.make,
          model: this.itemModel.model,
          itemType: this.itemModel.itemType,
          provisioningId: this.itemModel.provisioningId,
        };
        await this.$store.dispatch("itemModel/createItemModelAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Item Model Created Successfully!",
          type: "success",
        });
        this.$router.push(`/inventory/item-model`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getItemModelTemplate() {
      try {
        await this.$store.dispatch("itemModel/fetchItemModelTemplate");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    resetForm() {
      this.itemModel = itemModelEmptyObj;
      this.itemModel.make = "";
      this.itemModel.model = "";
      this.itemModel.itemType = "";
      this.provisioning = "";
      this.$router.push({ path: "/inventory/item-model" });
    },
  },
  watch: {
    // data(val) {
    //   this.provisionDatas = val.provisionDatas;
    // },
    provisionDatas(val) {
      val.forEach((temp) => {
        this.provsCodes.push(temp.systemcode);
        this.provsIds.push(temp.id);
      });
    },
    provisioning(val) {
      let indx = this.provsCodes.indexOf(val);
      this.itemModel.provisioningId = this.provsIds[indx];
    },
  },
  mounted() {
    this.getItemModelTemplate();
  },
};
</script>
